import { render, staticRenderFns } from "./PendingReasonList.vue?vue&type=template&id=7c037586"
import script from "./PendingReasonList.js?vue&type=script&lang=js&external"
export * from "./PendingReasonList.js?vue&type=script&lang=js&external"
import style0 from "./PendingReasonList.vue?vue&type=style&index=0&id=7c037586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports